export enum OperationExecutionStatus {
  CANCELLED = 'cancelled',
  DOWNLOADED = 'downloaded',
  FAILED = 'failed',
  FINISHED = 'finished',
  IN_PROGRESS = 'in progress',
  NO_DATA = 'no data',
  OBJECT_PROCESSED = 'object_processed',
  OBJECT_RESTRICTED = 'object_restricted',
  OPERATION_COMPLETE = 'operation complete',
  QUEUED = 'queued',
  REGISTERED = 'registered',
  RETRYING = 'retrying',
  RUNNING = 'running',
  STEP_COMPLETE = 'step complete',
  STOPPED = 'stopped',
}
